// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-header {
  margin-bottom: 2rem;
  padding-top: 1rem;
  padding-left: 2rem;
}

.project-title {
  position: relative;
}

.project-name-input {
  width: 100%;
  max-width: 300px;
  background: #e8e8e8;
  border: none;
  border-radius: 25px;
  padding: 8px 16px;
  font-size: 0.9rem;
  font-weight: 400;
  color: #666;
  outline: none;
  transition: all 0.3s ease;
}

.title-input-container {
  position: relative;
  display: inline-block;
}

.settings-icon-btn {
  position: absolute;
  right: -40px;
  top: 50%;
  transform: translateY(-50%);
  background: #f09502;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: white;
}

.settings-icon-btn:hover {
  background: #d87a01;
  transform: translateY(-50%) scale(1.1);
}

.settings-icon-btn svg {
  width: 16px;
  height: 16px;
}

.project-name-input:focus {
  background: #fff;
  box-shadow: 0 0 0 2px #f09502;
}

.project-name-input::placeholder {
  color: #333;
  font-weight: bold;
  font-style: normal;
}

.title-underline {
  width: 100vw;
  height: 3px;
  background: linear-gradient(90deg, #f09502, #ff6b35);
  margin-top: 20px;
  border-radius: 2px;
  position: absolute;
  left: -2rem;
  right: 0;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
}

.project-title {
  position: relative;
  flex: 1;
}


.wallet-section {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding-right: 2rem;
}

.connect-wallet-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
  background-color: #f09502;
  border: 1px solid white;
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.3s ease;
  width: 100%;
  justify-content: center;
}

.connect-wallet-btn:hover {
  background-color: #d87a01;
  color: white;
  border: 1px solid white;
}

.connect-wallet-btn img {
  width: 30px;
  height: 30px;
  margin-right: 5px;
}

.wallet-address {
  border: 1px solid #424242;
  padding: 8px 16px;
  background-color: #0f0f0f;
  color: white;
  text-decoration: none;
  border-radius: 6px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.wallet-address:hover {
  background-color: #1a1a1a;
  color: white;
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/new-proyect/new-project-header/new-project-header.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oDAAoD;EACpD,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,OAAO;AACT;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB","sourcesContent":[".project-header {\n  margin-bottom: 2rem;\n  padding-top: 1rem;\n  padding-left: 2rem;\n}\n\n.project-title {\n  position: relative;\n}\n\n.project-name-input {\n  width: 100%;\n  max-width: 300px;\n  background: #e8e8e8;\n  border: none;\n  border-radius: 25px;\n  padding: 8px 16px;\n  font-size: 0.9rem;\n  font-weight: 400;\n  color: #666;\n  outline: none;\n  transition: all 0.3s ease;\n}\n\n.title-input-container {\n  position: relative;\n  display: inline-block;\n}\n\n.settings-icon-btn {\n  position: absolute;\n  right: -40px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: #f09502;\n  border: none;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: white;\n}\n\n.settings-icon-btn:hover {\n  background: #d87a01;\n  transform: translateY(-50%) scale(1.1);\n}\n\n.settings-icon-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.project-name-input:focus {\n  background: #fff;\n  box-shadow: 0 0 0 2px #f09502;\n}\n\n.project-name-input::placeholder {\n  color: #333;\n  font-weight: bold;\n  font-style: normal;\n}\n\n.title-underline {\n  width: 100vw;\n  height: 3px;\n  background: linear-gradient(90deg, #f09502, #ff6b35);\n  margin-top: 20px;\n  border-radius: 2px;\n  position: absolute;\n  left: -2rem;\n  right: 0;\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 2rem;\n}\n\n.project-title {\n  position: relative;\n  flex: 1;\n}\n\n\n.wallet-section {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  padding-right: 2rem;\n}\n\n.connect-wallet-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: white;\n  background-color: #f09502;\n  border: 1px solid white;\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  width: 100%;\n  justify-content: center;\n}\n\n.connect-wallet-btn:hover {\n  background-color: #d87a01;\n  color: white;\n  border: 1px solid white;\n}\n\n.connect-wallet-btn img {\n  width: 30px;\n  height: 30px;\n  margin-right: 5px;\n}\n\n.wallet-address {\n  border: 1px solid #424242;\n  padding: 8px 16px;\n  background-color: #0f0f0f;\n  color: white;\n  text-decoration: none;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n}\n\n.wallet-address:hover {\n  background-color: #1a1a1a;\n  color: white;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
